// Crawlers that execute JavaScript (e.g. Meta's crawler) load recording pages
// and send watch heartbeats, which the datalake counts as replay attendance.
// Kept conservative: a real learner's browser never matches these.
const BOT_USER_AGENT =
  /Googlebot|bingbot|Applebot|AdsBot|crawler|spider|HeadlessChrome|facebookexternalhit|meta-external|Lighthouse/i

export function isAutomatedBrowser(nav: Pick<Navigator, 'userAgent' | 'webdriver'> | undefined): boolean {
  if (!nav) return false
  if (nav.webdriver === true) return true
  return BOT_USER_AGENT.test(nav.userAgent || '')
}
